import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { computed, ref, watch } from 'vue';
import { BFormGroup, BFormSelect, BTooltip } from 'bootstrap-vue-next';
import {
  CloudRegionPrefixSelectOptions,
  countryToRegionLabel,
} from '@/utils/cloud-utils';
import { useUserStore } from '@/store/user';


export default /*@__PURE__*/_defineComponent({
  __name: 'CloudRegionSelection',
  props: {
    modelValue: {},
    modelRequired: { type: Boolean }
  },
  emits: ["update:modelValue", "update:modelRequired"],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();

/* ───────────────────────── props / emits ───────────────────────── */
const props = __props;

const emit = __emit;

/* ───────────────────────── local state (writable copies) ───────── */
const prefix = ref<string | null>(props.modelValue ?? null);
const required = ref<boolean>(props.modelRequired ?? false);

/* sync locals ↔︎ parent */
watch(prefix, (v) => emit('update:modelValue', v));
watch(required, (v) => emit('update:modelRequired', v));

const defaultRegion = computed(() => {
  if (userStore.activeOrgAssociation?.organization?.addressCountryCode) {
    return countryToRegionLabel(
      userStore.activeOrgAssociation.organization.addressCountryCode
    );
  }
  return null;
});

// handlers
function toggleCustomCloudRegion() {
  required.value = !required.value;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([required.value ? 'expanded-group' : 'collapsed-group'])
  }, [
    _createElementVNode("label", {
      id: "cloud-region-help-label",
      role: "button",
      tabindex: "0",
      style: {"cursor":"pointer"},
      onClick: _withModifiers(toggleCustomCloudRegion, ["stop"]),
      class: _normalizeClass(required.value ? 'mb-2' : 'mb-0')
    }, [
      _createVNode(_component_font_awesome_icon, {
        icon: ['fas', 'globe'],
        class: "me-1"
      }),
      (required.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _cache[1] || (_cache[1] = _createTextVNode(" Data Location ", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fas fa-angle-up ms-1" }, null, -1))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[3] || (_cache[3] = _createTextVNode(" Data Location: ", -1)),
            (defaultRegion.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(defaultRegion.value), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, "Based on your organization settings")),
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-angle-down ms-1" }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
            _cache[6] || (_cache[6] = _createElementVNode("small", null, " Double-check the location satisfies the regulatory requirements. ", -1))
          ], 64))
    ], 2),
    (!required.value)
      ? (_openBlock(), _createBlock(_unref(BTooltip), {
          key: 0,
          target: "cloud-region-help-label"
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Click to change where your data will be stored or processed. Choose a region that meets any legal/compliance requirements and, if possible, is close to the data source to reduce transfer time. ", -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (required.value)
      ? (_openBlock(), _createBlock(_unref(BFormGroup), { key: 1 }, {
          default: _withCtx(() => [
            _createVNode(_unref(BFormSelect), {
              options: _unref(CloudRegionPrefixSelectOptions),
              modelValue: prefix.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prefix).value = $event)),
              id: "gcp-zone",
              name: "gcp-zone"
            }, null, 8, ["options", "modelValue"]),
            _cache[8] || (_cache[8] = _createElementVNode("small", null, " Select the region in which the data will be stored or processed. Pick a location that satisfies regulatory requirements and is geographically close to the data source to minimise transfer time. ", -1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})